module.exports = __webpack_public_path__ + "img/icon_arrow_right_dark_grey.20f6bd83.svg";